// /client/packs/controllers/name_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  validate() {
    const input = this.inputTarget
    let error = input.parentNode.querySelector(".invalid-feedback")

    if (input.value.length == 0) {
      input.classList.add("is-invalid")
      if (!error) {
        error = document.createElement("div")
        error.classList.add("invalid-feedback")
        error.innerText = "Name cannot be blank"
      }
      input.parentNode.insertBefore(error, input.nextSibling)
    } else {
      if (error) {
        input.classList.remove("is-invalid")
        error.remove()
      }
    }
  
  }
}